export default __webpack_public_path__ + "static/media/gallery-4.54de2294.png";